<template>
  <div class="blog-post-card31-blog-post-card" v-bind:class="rootClassName">
    <div class="blog-post-card31-container1">
      <h1 class="blog-post-card31-text1">{{ title }}</h1>
      <div class="blog-post-card31-container2">
        <span class="blog-post-card31-text2">{{ description }}</span>
      </div>
      <span class="blog-post-card31-text3">{{ author }}</span>
    </div>
    <img :alt="imageAlt" :src="imageSrc" class="blog-post-card31-image" />
  </div>
</template>

<script>
export default {
  name: "BlogPostCard31",
  props: {
    imageAlt: {
      type: String,
      default: "image",
    },
    author: {
      type: String,
      default: "by Jon Doe 5 hours ago",
    },
    rootClassName: String,
    imageSrc: {
      type: String,
      default:
        "https://images.unsplash.com/photo-1554415707-6e8cfc93fe23?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDF8fHdvcmtpbmclMjBkZXNrfGVufDB8fHx8MTYyNjI1MDYwMg&ixlib=rb-1.2.1&h=1200",
    },
    description: {
      type: String,
      default:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non volutpat turpis. Mauris luctus rutrum mi ut rhoncus. Integer in dignissim tortor. Lorem ipsum dolor sit amet, consectetur adipiscing ...",
    },
    title: {
      type: String,
      default: "Lorem ipsum dolor sit amet",
    },
  },
};
</script>

<style scoped>
.blog-post-card31-blog-post-card {
  width: 100%;
  display: flex;
  max-width: 1400px;
  flex-direction: row;
  justify-content: center;
}
.blog-post-card31-container1 {
  flex: 1;
  display: flex;
  padding: 32px;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.blog-post-card31-text1 {
  align-self: flex-end;
  margin-bottom: var(--dl-space-space-doubleunit);
}
.blog-post-card31-container2 {
  display: flex;
  align-items: flex-start;
  margin-bottom: 48px;
  flex-direction: column;
  justify-content: flex-start;
}
.blog-post-card31-text2 {
  color: var(--dl-color-gray-500);
  width: 50%;
  align-self: flex-end;
  text-align: right;
  margin-bottom: var(--dl-space-space-halfunit);
  margin-left: 300px;
}
.blog-post-card31-text3 {
  color: black;
  align-self: flex-end;
  font-weight: bold;
}
.blog-post-card31-image {
  width: 500px;
  height: 400px;
  object-fit: fill;
}

@media (max-width: 1600px) {
  .blog-post-card31-text1 {
    align-self: flex-end;
  }
  .blog-post-card31-container2 {
    align-self: flex-end;
  }
  .blog-post-card31-text2 {
    align-self: flex-end;
    text-align: right;
  }
  .blog-post-card31-text3 {
    align-self: flex-end;
  }
}
@media (max-width: 991px) {
  .blog-post-card31-image {
    width: 50%;
  }
}
@media (max-width: 767px) {
  .blog-post-card31-blog-post-card {
    flex-direction: column;
    justify-content: space-between;
  }
  .blog-post-card31-container1 {
    width: 100%;
  }
  .blog-post-card31-text1 {
    margin-bottom: 32px;
  }
  .blog-post-card31-container2 {
    margin-bottom: 32px;
  }
  .blog-post-card31-image {
    width: 100%;
  }
}
</style>
